var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientshotIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_20477)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.427 18.9414C34.4809 18.3863 34.5085 17.8235 34.5085 17.2542C34.5085 7.72498 26.7835 0 17.2542 0C7.72498 0 0 7.72498 0 17.2542C0 26.1829 6.78186 33.5275 15.4753 34.4179L16.36 29.2599L9.86728 22.936C9.36329 22.4451 9.18162 21.7107 9.39861 21.0415C9.61561 20.3723 10.1936 19.8842 10.8898 19.7825L19.8647 18.4706L23.878 10.3402C24.1894 9.70928 24.832 9.30984 25.5357 9.30984C26.2393 9.30984 26.8819 9.70928 27.1934 10.3402L31.2066 18.4706L34.427 18.9414ZM33.6747 22.568L29.7113 21.9887C29.1098 21.9008 28.59 21.5228 28.3209 20.9777L25.5357 15.3351L22.7504 20.9777C22.4814 21.5228 21.9616 21.9008 21.3601 21.9887L15.1289 22.8995L19.6363 27.2897C20.0723 27.7144 20.2714 28.3266 20.1685 28.9265L19.2303 34.3965C19.8636 34.3243 20.4864 34.2179 21.097 34.079L24.6752 32.1972C25.1176 31.9646 25.6307 31.923 26.0984 32.0725C29.6524 29.9467 32.3778 26.5786 33.6747 22.568Z",
    fill: "#8A6CC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4083 34.6908L26.0342 31.9563L31.2176 27.0883L33.4083 34.6908Z",
    fill: "#8A6CC8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_20477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientshotIconLogo);
export default __webpack_public_path__ + "static/media/Clientshot_icon_logo.3deacb40cbaf3a8668727e42a7bf7780.svg";
export { ForwardRef as ReactComponent };